import { render, staticRenderFns } from "./PastAppointments.vue?vue&type=template&id=093c821f"
import script from "./PastAppointments.vue?vue&type=script&lang=js"
export * from "./PastAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports